import Model from "./Model";

export default class extends Model {
    constructor(urls) {
        super(urls);
    }

    async loadTable(page = 1, limit = 10, name = '', client = '') {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                name,
                client
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });
        
        let result = {
            items: [],
            pages: response.pages,
            count: response.count,
            status: response.status
        };

        if(response)
        {
            result.items = response.items;
        }

        return result;
    }
}
